import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { Options } from '@angular-slider/ngx-slider';
import { Product } from '../interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../interfaces/plan-attributes.interface';
import { PlanUtilityService } from '../plan-summary-list/plan-utility.service';

@Component({
    selector: 'app-plan-price-slider',
    templateUrl: './plan-price-slider.component.html',
    styleUrls: ['./plan-price-slider.component.scss'],
    standalone: false
})
export class PlanPriceSliderComponent implements OnInit {
  @Input() plans?: Product<PlanAttributes, SummaryView>[];
  @Input() id?: string; // I don't think this ever has a value

  value: number;
  highValue: number;
  @Input() options: Options;
  @Output() private valuesChanged = new EventEmitter<{}>();

  constructor(
    // private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService,
    private planUtilityService: PlanUtilityService
  ) { }

  ngOnInit() {
    this.setSliderDefaults();
  }

  setSliderDefaults() {
    // const planSliderState: PlanPriceSliderStateStructure = this.reducerUtilityService.getState('PlanPriceSlider');

    const minAndMaxPrices = this.planUtilityService.getPlanMinimumAndMaximumPrices(this.plans);

    this.value = minAndMaxPrices.min;
    this.highValue = minAndMaxPrices.max;

    if (this.value) {
      this.valuesChanged.emit({ id: this.id, value: this.value });
    }

    if (this.highValue) {
      this.valuesChanged.emit({ id: this.id, highValue: this.highValue });
    }
  }

  valueChange(event: number) {
    this.value = event;
    this.valuesChanged.emit({ value: this.value });
    // this.ngRedux.dispatch(saveValue(this.value));
  }

  highValueChange(event: number) {
    this.highValue = event;
    this.valuesChanged.emit({ highValue: this.highValue });
    // this.ngRedux.dispatch(saveHighValue(this.highValue));
  }
}
